import { Icon, IconButton, P } from '@fashionnovateam/nova-ui-toolkit';
import React from 'react';
import { useCounterContext } from '../hooks/useCounter';

function DrawerHeader({ closeDrawer }: { closeDrawer: () => void }) {
  const {
    selectedCounter,
    setSelectedCounter,
    getNextCounter,
    getPrevCounter,
  } = useCounterContext();

  const handleNext = () => {
    const nextCounter = getNextCounter();
    if (nextCounter) {
      setSelectedCounter(nextCounter);
    }
  };

  const handlePrev = () => {
    const prevCounter = getPrevCounter();
    if (prevCounter) {
      setSelectedCounter(prevCounter);
    }
  };

  return (
    <div className="flex items-center border-b border-neutral-200 py-3 px-5 gap-4 h-15 w-full">
      <IconButton
        label="Close"
        size="sm"
        icon={<Icon name="multiple-cross/multiple-cross-cancel-default" />}
        onClick={closeDrawer}
        color="secondary"
      />
      {selectedCounter?.photos?.[0] && (
        <img
          alt={`${selectedCounter.counter_id}_photo`}
          src={selectedCounter?.photos?.[0]}
          className="rounded-md w-8 h-8"
        />
      )}
      <div className="grow">
        <P size="sm" weight="medium">
          {selectedCounter?.display_name}
        </P>
        <P size="2xs" weight="normal" color="disabled">
          {selectedCounter?.style_color}
        </P>
      </div>
      <div className="flex items-end gap-1">
        <IconButton
          label="next"
          color="secondary"
          icon={<Icon.ChevronUp />}
          type="button"
          onClick={handlePrev}
          disabled={!getPrevCounter()}
        />
        <IconButton
          label="prev"
          color="secondary"
          icon={<Icon.ChevronDown />}
          type="button"
          onClick={handleNext}
          disabled={!getNextCounter()}
        />
      </div>
    </div>
  );
}

export default DrawerHeader;
